import { render, staticRenderFns } from "./pop_msg.vue?vue&type=template&id=2d9761f9&scoped=true&"
import script from "./pop_msg.vue?vue&type=script&lang=js&"
export * from "./pop_msg.vue?vue&type=script&lang=js&"
import style0 from "./pop_msg.vue?vue&type=style&index=0&id=2d9761f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9761f9",
  null
  
)

export default component.exports